import { Box, Button, Flex, Heading, HStack, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';

// Components
import SlideModal from "../../Components/Slide/SlideModal";

// Images
import OfertaCelularesMovil1 from '../../Assets/OFERTAS/ofertaCelularesMovil1.webp';
import OfertaCelularesMovil2 from '../../Assets/OFERTAS/ofertaCelularesMovil2.webp';
import OfertaCelulares1 from '../../Assets/OFERTAS/ofertaCelulares1.webp';
import OfertaCelulares2 from '../../Assets/OFERTAS/ofertaCelulares2.webp';
import Oferta1 from '../../Assets/OFERTAS/ofertaEntel1.webp';
import Oferta2 from '../../Assets/OFERTAS/ofertaEntel2.webp';
import latam from "../../Assets/MOVIL/latam.webp";

// Styles
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/skyblue';
import './style.css';

const Ofertas = () => {
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [segmento, setSegmento] = useState('');
    const [seccion, setSeccion] = useState('');
    const [id, setId] = useState('');
    const navigate = useNavigate();

    const openSlide = (idButton, description, view) => {
        window.dataLayer.push({
            'event': 'GARDevent',
            'eventCategory': 'entel ofertas - card',
            'eventAction': 'click to action',
            'eventLabel': `revisar planes`,
            'description': description,
            'origen': 'entel',
            'segmento': view === 'movil' ? 'po' : 'hh',
            'mercado': 'pe',
        });

        setSegmento(view === 'movil' ? 'po' : 'hh');
        setOpenSlideModal(true);
        setSeccion(view);
        setId(idButton);
    };

    const openSlideOfertas = (idButton = '', descuento = '', product = '', position = '', price = '', subprice = '', seccion) => {
        window.dataLayer.push({
            'event': 'GARDevent',
            'eventCategory': 'entel ofertas - card',
            'eventAction': 'click to action',
            'eventLabel': 'oferta equipo',
            'origen': 'entel',
            'product': product,
            'product_price': price,
            'product_subprice': subprice,
            'type_offer': descuento,
            'position': position,
            'segmento': 'tm-equ',
            'mercado': 'pe',
        });

        setSeccion(seccion);
        setOpenSlideModal(true);
        setSegmento('tm-equ');
        setId(idButton);
    };

    const navegationSection = (page, section) => {
        navigate(page, {
            state: { section }
        });
    }

    return (
        <>
            {/* Cuando eres Entel se nota */}
            <Box mt={[5, 5, 10, 10, 10]} w='90%' mx='auto'>
                <Heading className="General" as='h1' fontWeight='500' fontSize={['26px', '26px', '46px', '46px', '46px']} textAlign='center'>
                    Cuando eres Entel se nota
                </Heading>
            </Box>

            {/* Tarjetas Movil - Fibra */}
            <SimpleGrid columns={[1, 1, 2, 2, 2]} spacing='5' mt='5' w='90%' mx='auto'>
                {/* Target movil */}
                <Box backgroundImage={Oferta2} position='relative' backgroundSize="cover" backgroundPosition='center' backgroundRepeat="no-repeat" width='100%' height={'100%'} borderRadius='12px' px='5' boxShadow='0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset'>
                    {/* <Box mt='4' mb='5'>
                        <Image src={latam} alt='entel millas latam' />
                    </Box> */}

                    <Box mt='4' mb='2'>
                        <svg width="219" height="48" viewBox="0 0 219 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M39.0206 13.133C38.6297 12.8628 38.029 12.9088 37.6841 13.2249L35.4567 15.2627C35.1089 15.5846 35.1376 16.0761 35.517 16.352C35.517 16.352 38.9516 18.8698 38.9516 24.2847C38.9516 29.6996 35.3359 32.3725 35.3359 32.3725C34.968 32.6743 34.9566 33.1802 35.3043 33.4992L37.5117 35.5054C37.8566 35.8215 38.463 35.8675 38.8539 35.6002C38.8539 35.6002 44.0389 32.0765 44.0389 24.3048C44.0389 16.5331 39.0235 13.1387 39.0235 13.1387" fill="#FF3D00"/>
                            <path d="M17.5622 25.8135C17.5622 25.8135 16.9184 25.7532 16.9184 26.2676C16.9184 29.2021 19.1085 31.2888 22.5402 31.2888C25.0925 31.2888 26.1818 30.6823 27.7252 29.5269C28.0845 29.2567 28.4639 29.0067 28.7599 29.3229C28.9611 29.5413 31.6685 32.0389 31.6685 32.0389C32.0077 32.3551 31.9157 32.7345 31.5507 33.042C31.1914 33.3467 27.1446 36.491 22.4942 36.491C16.4068 36.491 10.5723 33.8439 10.5723 23.8763C10.5723 15.846 15.1249 11.3105 21.7987 11.3105C28.9726 11.3105 33.028 16.3173 33.028 23.0716V24.7817C33.028 25.4772 32.4618 25.8164 31.9962 25.8164H17.5622V25.8135ZM26.1042 18.9644C25.4173 17.5015 23.9802 16.4122 21.8044 16.4122C19.6287 16.4122 18.1974 17.5015 17.5018 18.9644C17.1023 19.8611 16.9558 20.5251 16.9069 21.6086H26.702C26.6531 20.5251 26.5008 19.864 26.1071 18.9644" fill="white"/>
                            <path d="M57.1748 10L57.1748 37.794" stroke-width="0.524428" stroke="#66686C"/>
                            <path d="M69.7676 27.6601H72.7195C72.8263 28.5594 73.1167 29.2023 73.5867 29.5718C74.0566 29.9456 74.7486 30.1314 75.6713 30.1314C77.4271 30.1314 78.3092 29.4095 78.3092 27.9677C78.3092 27.3184 78.1362 26.8228 77.7902 26.4811C77.4378 26.1393 76.8846 25.9044 76.1242 25.7826L74.5756 25.5135C71.613 25.0222 70.1264 23.5014 70.1264 20.9468C70.1264 19.4261 70.6305 18.2257 71.6365 17.335C72.6426 16.4464 73.9797 16 75.6436 16C77.3075 16 78.5442 16.4315 79.484 17.2858C80.4281 18.1402 80.9599 19.3492 81.0881 20.902H78.0914C78.0465 20.1074 77.8116 19.5329 77.4036 19.1633C76.9892 18.8002 76.3869 18.6165 75.5987 18.6165C74.8105 18.6165 74.1783 18.8002 73.7703 19.1762C73.356 19.5457 73.1509 20.0583 73.1509 20.7076C73.1509 21.2779 73.3303 21.7307 73.6977 22.0597C74.0608 22.395 74.6311 22.63 75.4086 22.7752L77.1473 23.0828C79.971 23.5912 81.385 25.129 81.385 27.6943C81.385 29.3433 80.8531 30.6056 79.8023 31.4728C78.745 32.3443 77.3267 32.78 75.5325 32.78C73.7383 32.78 72.4012 32.3378 71.4187 31.46C70.4297 30.5928 69.8808 29.3198 69.7697 27.658L69.7676 27.6601Z" fill="white"/>
                            <path d="M95.3859 18.9523V32.648H92.2439V18.9523H88.0575V16.2461H99.5724V18.9566H95.3859V18.9502V18.9523Z" fill="white"/>
                            <path d="M108.319 29.4655L107.324 32.6523H104.043L109.868 16.2461H112.411L118.264 32.6523H114.955L113.96 29.4655H108.319ZM111.132 20.5735L109.158 26.8788H113.127L111.132 20.5735Z" fill="white"/>
                            <path d="M128.593 25.9946V32.6523H125.475V16.2461H131.708C133.305 16.2461 134.587 16.6882 135.537 17.5661C136.488 18.4483 136.962 19.6401 136.962 21.1438C136.962 22.2225 136.71 23.1345 136.212 23.8778C135.715 24.6211 134.993 25.1701 134.059 25.5161L137.631 32.648H134.042L130.928 25.9903H128.591V25.9967L128.593 25.9946ZM131.539 23.4015C132.265 23.4015 132.831 23.205 133.239 22.8205C133.641 22.4297 133.844 21.87 133.844 21.1438C133.844 20.4795 133.636 19.9477 133.228 19.5504C132.814 19.1531 132.25 18.9587 131.541 18.9587H128.589V23.4037H131.541L131.539 23.4015Z" fill="white"/>
                            <path d="M148.332 16.2461V29.9418H155.515V32.6523H145.22V16.2461H148.334H148.332Z" fill="white"/>
                            <path d="M166.46 16.2461V32.6523H163.346V16.2461H166.46Z" fill="white"/>
                            <path d="M187.387 32.6523H184.273L178.231 22.3998V32.6523H175.116V16.2461H178.231L184.273 26.52V16.2461H187.387V32.6523Z" fill="white"/>
                            <path d="M208.734 16.2461H205.094L199.165 24.4182V16.2461H196.047V32.6523H199.165V24.4802L205.094 32.6523H208.734L202.781 24.446L208.734 16.2461Z" fill="white"/>
                        </svg>

                    </Box>

                    <Box mt='2' mb='24' color='white'>
                        <Text className="General" fontSize={['26px', '26px', '42px', '42px', '42px']} lineHeight='1'>Un plan que te</Text>
                        <Text className="General" fontSize={['26px', '26px', '42px', '42px', '42px']} lineHeight='1'>acompaña <b>en todas</b></Text>
                        <Text className="General" mt="3" fontSize={['15px']} lineHeight='1'>Planes móviles con <b>cobertura satelital</b></Text>

                    </Box>

                    {/* <Button className="Subtitle" id='oferta_tarjeta_movil' position='absolute' bottom={7} h='' py={[2, 2, 3, 3, 3]} onClick={() => openSlide('oferta-tarjeta-movil', '30porciento en planes moviles', 'movil')} borderRadius='30px' bg='white' border='1px solid #002EFF' color='#002EFF' px='10' _hover={{ bg: '#BECBFF' }}>
                        Revisar planes
                    </Button> */}

                    <Button className="Subtitle" id='oferta_tarjeta_movil' position='absolute' bottom={7} h='' py={[2, 2, 3, 3, 3]} onClick={() => navegationSection('/planes-moviles', 'id-secction-slider-plan-position-moviles')} borderRadius='30px' bg='white' border='1px solid #002EFF' color='#002EFF' px='10' _hover={{ bg: '#BECBFF' }}>
                        Revisar planes
                    </Button>
                </Box>

                {/* Target fibra */}
                <Box backgroundImage={Oferta1} position='relative' backgroundSize="cover" backgroundPosition='center' backgroundRepeat="no-repeat" width='100%' height='100%' borderRadius='12px' px='5' boxShadow='0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset'>

                    <Box mt='20' mb='24' width="50%" color='white'>
                        <Text className="General" fontSize={'32px'} lineHeight='1'><b>Fibra con</b></Text>
                        <Text className="General" fontSize={'32px'} lineHeight='1'><b>hasta 32% dcto</b></Text>
                        <Text className="General" fontSize={'32px'} lineHeight='1'><b>por 1 año</b></Text>
                    </Box>

                    {/* <Button className="Subtitle" id='oferta_tarjeta_hogar' position='absolute' bottom='7' h='' py={[2, 2, 3, 3, 3]} onClick={() => openSlide('oferta-tarjeta-hogar', 'fibra sin limites desde 15990 mes', 'hogar')} borderRadius='30px' bg='white' border='1px solid #002EFF' color='#002EFF' px='10' _hover={{ bg: '#BECBFF' }}>
                        Revisar planes
                    </Button> */}

                    <Button className="Subtitle" id='oferta_tarjeta_hogar' position='absolute' bottom='7' h='' py={[2, 2, 3, 3, 3]} onClick={() => navegationSection('/internet-hogar/internet', 'id-secction-slider-plan-position-internet-hogar')} borderRadius='30px' bg='white' border='1px solid #002EFF' color='#002EFF' px='10' _hover={{ bg: '#BECBFF' }}>
                        Revisar planes
                    </Button>
                </Box>
            </SimpleGrid>

            {/* Ofertas */}
            <Flex flexDirection={['column', 'column', 'row', 'row', 'row']} mt='5' w='90%' mx='auto'>
                {/* Texto Desktop */}
                <Box w={['100%', '100%', '30%', '30%', '30%']} m='auto'>
                    <Heading className="General" fontWeight='200' size={['lg', 'lg', 'xl', 'xl', 'xl']}>Encuentra los mejores equipos y tecnología</Heading>
                </Box>

                {/* Oferta 1 */}
                <Box display={['none', 'none', 'flex', 'flex', 'flex']} mx='15px' my='auto'>
                    <Image src={OfertaCelulares1} w='100%' cursor='pointer' onClick={() => openSlideOfertas('oferta-tarjeta-uno', 'no aplica', 'apple iphone 17 pro max 256gb', 1, '1549990', 'no aplica', 'equipos')} />
                </Box>
                <Image w='100%' display={['flex', 'flex', 'none', 'none', 'none']} my='24px' src={OfertaCelularesMovil1} h='100%' cursor='pointer' onClick={() => openSlideOfertas('oferta-tarjeta-uno', 'no aplica', 'apple iphone 17 pro max 256gb', 1, '1549990', 'no aplica', 'equipos')} />

                {/* Oferta 2 */}
                <Box display={['none', 'none', 'flex', 'flex', 'flex']} my='auto'>
                    <Image dropShadow='10px 10px 10px #bbb' w='100%' display={['none', 'none', 'flex', 'flex', 'block']} src={OfertaCelulares2} cursor='pointer' onClick={() => openSlideOfertas('oferta-tarjeta-dos', 'no aplica', 'apple ipad air', 2, '749990', 'no aplica', 'accesorios')} />
                </Box>
                <Image display={['flex', 'flex', 'none', 'none', 'none']} w={'100%'} src={OfertaCelularesMovil2} h='auto' cursor='pointer' onClick={() => openSlideOfertas('oferta-tarjeta-dos', 'no aplica', 'apple ipad air', 2, '749990', 'no aplica', 'accesorios')} />

            </Flex>

            {/* Abrir modal */}
            {
                openSlideModal &&
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal
                        setOpenSlideModal={setOpenSlideModal}
                        priceTyc={''}
                        openSlideModal={openSlideModal}
                        descuento={''}
                        price={''}
                        valuePhoneInitial={''}
                        plan={''}
                        submitInitial={false}
                        view='ofertas'
                        segmentoInitial={segmento}
                        id={id}
                        seccion={seccion}
                    />
                </Box>
            }
        </>
    )
}

export default Ofertas